import { Col } from "react-grid-system"
import styled from "styled-components"
import media from "styleguide/styles/media-queries"

const ColWrapper = styled(Col)`
  ${media.phone`
    padding-left: 32px !important;
    padding-right: 32px !important;
  `}
`

export default ColWrapper
